export default "__VITE_ASSET__BFosMvc9__"